import { useNavigate } from "react-router-dom";
import { Plus, Share2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { MilestoneBadge, TIERS } from "@/pages/MilestonesRow";
import InviteNudge from "@/pages/InviteNudge";

export default function MilestoneDialog({ n, onClose }) {
  const navigate = useNavigate();
  const tier = n ? TIERS[n] : null;

  const share = async () => {
    const text = `Just hit ${n} sales on eBay — "${tier.label}" unlocked! Listed with SnapList.`;
    try {
      if (navigator.share) await navigator.share({ title: `${n} sales!`, text });
      else { await navigator.clipboard.writeText(text); toast.success("Copied — paste it anywhere to share"); }
    } catch { /* cancelled */ }
  };

  return (
    <Dialog open={!!n} onOpenChange={(open) => { if (!open) onClose(); }}>
      {n ? (
        <DialogContent className="max-w-sm rounded-2xl text-center" data-testid="milestone-dialog">
          <div className="mx-auto mt-2"><MilestoneBadge n={n} earned size="lg" /></div>
          <DialogHeader className="space-y-1 text-center sm:text-center">
            <DialogTitle className="text-3xl font-bold tracking-tight" data-testid="milestone-dialog-title">{n} sales!</DialogTitle>
            <DialogDescription data-testid="milestone-dialog-label">
              You unlocked the <span className="font-semibold text-slate-900">{tier.label}</span> badge. Keep it rolling.
            </DialogDescription>
          </DialogHeader>
          <div className="mt-2 grid grid-cols-2 gap-2">
            <Button variant="outline" onClick={share} className="h-11 rounded-full" data-testid="milestone-share">
              <Share2 className="mr-2 h-4 w-4" /> Share
            </Button>
            <Button onClick={() => { onClose(); navigate("/"); }} className="h-11 rounded-full bg-[#0053DA] hover:bg-[#0043B0]" data-testid="milestone-list-another">
              <Plus className="mr-2 h-4 w-4" /> List another
            </Button>
          </div>
          <InviteNudge compact />
        </DialogContent>
      ) : null}
    </Dialog>
  );
}
